<template>
  <div  >
    <Header
        :leftArrow="true"
        :leftText="''"
        @leftClick="onClickLeft"
        @onRefreshClick="onRefresh"
        :rightIcons="true"
    >
    </Header>
    <div>
      <van-form class="form_style" ref="form" style="margin-top: 20px;">
        <van-cell-group inset class="cell_style">
          <van-field
              name="switch"
              input-align="right"
              label="DZ機能ON/OFF"
              label-width="200px"
          >
            <template #input>
              <van-switch
                  v-model="dzOpenFlg"
                  size="20"
                  @change="changeDzOpenFlg"
                  active-color="#3B82C4"
              />
            </template>
          </van-field>
        </van-cell-group>
      </van-form>
      <van-form class="form_style" ref="form" style="margin-top: 20px;" v-show="dzOpenFlg">
        <van-cell-group inset class="cell_style">
          <van-field
              label-width="200px"
              is-link
              readonly
              name="newFace"
              label="新しい顔認識"
              @click="changeShowFaceType"
          >
          </van-field>
        </van-cell-group>
      </van-form>

      <van-form class="form_style" ref="form" style="margin-top: 20px;" v-show="!dzOpenFlg">
        <van-cell-group inset class="cell_style">
          <van-field
              label-width="200px"
              is-link
              readonly
              name="clearFace"
              label="資格認定情報の消去"
              @click="clearFace"
          >
          </van-field>
        </van-cell-group>
      </van-form>
    </div>

  </div>

</template>

<script>
import Header from "@/components/Header.vue";
import {Toast} from "vant";
import "vant/es/toast/style";

export default {
  name: "detailPage",
  props: {
  },
  data() {
    return {
      screenWidth: null,
      showFaceType: false,
      faceType: [{ name: '顔認証' ,value:"typeFace"}, { name: '画像認証',value:"typeImg" }],
      dzOpenFlg:false,
      overlayShow:false,
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.$store.state.routeViewComponent = this;
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
    this.checkDzExist();
  },
  beforeUnmount() {
    this.$store.state.routeViewComponent = null;
  },
  methods: {
    doMethods(params){
      if(params['method'] == 'cancelFaceType'){
        this.dzOpenFlg = false;
      }
    },
    checkDzExist(){
      // if (typeof cordova === "undefined") {
      //   Toast('Dz機能異常');
      //   history.back();
      // } else {
        let dzOpenFlg = localStorage.getItem("tsunagaru_dz_status");
        if("open" ==dzOpenFlg){
          this.dzOpenFlg = true;
        }else{
          this.dzOpenFlg = false;
        }
      // }
    },
    changeDzOpenFlg(){
      if(this.$root.monitorRoom !== ""){
        Toast('监视モードではdz機能は使用できません');
        this.dzOpenFlg = false;
      }else{
        // 开始dz认证
        let status = '';
        if(this.dzOpenFlg){
         status = 'open';
        }else{
          status = 'close';
        }
        this.$emit("dzAndroid",{toPage:"dzAndroid",method:"changeDzStatus",status:status});
      }
    },
    changeShowFaceType(){
      if(this.$root.monitorRoom !== ""){
        Toast('监视モードではdz機能は使用できません');
        this.dzOpenFlg = false;
      }else{
        this.$emit("dzAndroid",{toPage:"dzAndroid",method:"changeShowFaceType"});
      }
    },
    clearFace(){
      if(this.$root.monitorRoom !== ""){
        Toast('监视モードではdz機能は使用できません');
        this.dzOpenFlg = false;
      }else{
        this.$emit("dzAndroid",{toPage:"dzAndroid",method:"clearFace"});
      }
    },
    onClickLeft() {
      history.back();
    },
    onRefresh() {
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });
    },
  },
  watch: {
    screenWidth: function (n, o) {},
  },
};
</script>

<style scoped>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .overlayBox {
    width: 250px;
    height: 120px;
    background-color: #fff;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
  }
  .overlayBox .title{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 21px;
    font-size: 18px;
  }
  .overlayBox .content{
    color: red;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
  }

</style>
